import React from 'react';

import { Container } from './PartnerDetails.styled';
import { Loader } from 'components/Loader/Loader';
import { Alert } from 'components/v2/Alert/Alert';
import { useInterstitialStatus } from 'hooks/useInterstitialStatus';
import { Navigation } from 'screens/Book/components/Navigation/Navigation';
import { PartnerDetails as InterstitialPartnerDetails } from 'screens/InterstitialModal/components/partner/PartnerDetails';

export const PartnerDetailsStep = ({
  onBack,
  onNextStep
}: {
  onBack: () => void;
  onNextStep: () => void;
}) => {
  const { status, loading } = useInterstitialStatus();

  if (loading || !status) return <Loader container />;

  return (
    <Container>
      <Alert
        title="Almost there!"
        message="Please let us know whether you would like to include a partner before continuing"
        type="warning"
      />
      <InterstitialPartnerDetails status={status} />
      <Navigation
        onBack={onBack}
        step="partner"
        forwardText="Continue"
        forwardDisabled={!status.partnerDataCollected}
        forwardFunction={onNextStep}
      />
    </Container>
  );
};
